import { render, staticRenderFns } from "./incomingCall.vue?vue&type=template&id=0b272ddb"
import script from "./incomingCall.vue?vue&type=script&lang=js"
export * from "./incomingCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports